<template>
  <div
    class="z-10 h-14 md:h-15 aha-presentation-editor-header flex shadow-top items-center"
  >
    <span
      class="px-4 py-4 cursor-pointer"
      @click="backToSlideTypeList"
    >
      <img src="@/assets/images/google-slides/back-slide-type-list.svg" alt="">
    </span>
    <div class="flex-grow pr-2 text-center font-bold">
      <span v-if="!isSettingsContentVisible">Content</span>
      <span v-if="isSettingsContentVisible">General quiz settings</span>
    </div>
    <div class="mr-2">
      <SyncLoading />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import SyncLoading from '@/components-v2/presentation-editor/editor-header/SyncLoading'
import GoogleSlideService from '@/services/google-slide'

export default {
  components: {
    SyncLoading,
  },
  data() {
    return {
      showPresentOptions: false,
    }
  },

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('rightPanelContainer', ['isSettingsContentVisible', 'isQuizTeamSetUpVisible']),
    ...mapGetters('rightNav', ['rightNavTabNames']),
  },
  mounted() {

  },
  destroyed() {
  },
  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction', 'setSlideActiveAction', 'updateGoogleSlideActiveId']),
    backToSlideTypeList() {
      if (this.isSettingsContentVisible) {
        this.setRightNavActiveTabAction(this.rightNavTabNames.CONTENT)
      } else {
        this.setSlideActiveAction({
          activeTab: 1,
        })
        this.handleAfterLoadedPresentation()
      }
    },
    async handleAfterLoadedPresentation() {
      const index = await GoogleSlideService.getIndexGoogleSlideActive()
      if (index !== -1) {
        this.updateGoogleSlideActiveId(this.presentation.slides[index].id)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-presentation-editor-header {
  background-color: #fff;
  position: sticky;
  top: 0;
}
</style>
